import { Loader2 } from 'lucide-react';
import { LlmTab } from '../phone/tabs/LlmTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';
import { SectionFrame } from './SectionFrame';

export function LlmSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  return (
    <SectionFrame
      title="KI-Modell"
      description="LLM-Provider, Modell, System-Prompt und Wissensbasis."
    >
      {loading ? (
        <div className="flex h-32 items-center justify-center text-muted-foreground">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
        </div>
      ) : (
        <LlmTab form={form} setForm={setForm} />
      )}
    </SectionFrame>
  );
}
